import Immutable from 'immutable'
import { createSelector } from 'reselect'

// ------------------------------------
// Constants
// ------------------------------------
export const BEGIN = 'inf/loading/BEGIN'
export const END = 'inf/loading/END'
export const RECEIVE_ERROR = 'inf/loading/RECEIVE_ERROR'

// ------------------------------------
// Actions
// ------------------------------------
function makeIterable(keys = []) {
  if (keys && (typeof keys[Symbol.iterator] !== 'function' || typeof keys === 'string')) {
    keys = [keys]
  }

  return Immutable.Set(keys)
}

export const begin = (type, keys) => ({
  payload: {
    keys: makeIterable(keys),
    type,
  },
  type: BEGIN,
})
export const end = (type, keys) => ({
  payload: {
    keys: makeIterable(keys),
    type,
  },
  type: END,
})
export const receiveError = (type, keys, error) => ({
  payload: {
    error,
    keys: makeIterable(keys),
    type,
  },
  type: RECEIVE_ERROR,
})

// ------------------------------------
// Selectors
// ------------------------------------
export const makeSelectError = () => createSelector(
  state => state.loading.get('errors'),
  (state, { key }) => key,
  (state, { type }) => type,
  (errors, key, type) => errors.getIn([type, key], null),
)

export const makeSelectLoading = () => createSelector(
  state => state.loading.get('loading'),
  (state, { type }) => makeIterable(type),
  (loading, types) => loading.intersect(types).size > 0,
)

export const makeSelectLoadingOrError = () => createSelector(
  state => state.loading.get('loadingKey'),
  state => state.loading.get('errors'),
  (state, { key }) => key,
  (state, { type }) => type,
  (loading, errors, key, type) => loading.hasIn([type, key], false) || errors.hasIn([type, key], false),
)

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  errors: Immutable.Map(),
  // TODO: it might make more sense if we keep track of how many
  // begin() and end() calls are made, in case more than one
  // request gets made in an async manner..
  loading: Immutable.Set(),
  loadingKey: Immutable.Map(),
})

function addErrors(state, type, keys, error) {
  if (!state.hasIn(['errors', type])) {
    state = state.setIn(['errors', type], Immutable.Map())
  }

  return keys.reduce((s, key) => s.setIn(['errors', type, key], error), state)
}

function ensureKeys(keyState, type, keys) {
  if (!keyState.has(type)) {
    keyState = keyState.set(type, Immutable.Set())
  }

  if (!keys.size) {
    return keyState
  }

  return keyState.set(type, keyState.get(type).union(keys))
}

function removeKeys(keyState, type, keys) {
  if (!keyState.has(type) || !keys.size) {
    return keyState
  }

  return keyState.set(type, keyState.get(type).subtract(keys))
}

export default function reducer(state = initialState, { payload, type }) {
  switch (type) {
    case BEGIN: {
      const keyState = state.get('loadingKey')

      return state
        .set('loading', state.get('loading').add(payload.type))
        .set('loadingKey', ensureKeys(keyState, payload.type, payload.keys))
    }

    case END: {
      const keyState = state.get('loadingKey')

      return state
        .set('loading', state.get('loading').delete(payload.type))
        .set('loadingKey', removeKeys(keyState, payload.type, payload.keys))
    }

    case RECEIVE_ERROR:
      return addErrors(state, payload.type, payload.keys, payload.error)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/loading.js